import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";

const StatsStrip = () => {
  const { t } = useLang();
  const stats = [
    { value: "786", label: t("stats.career") },
    { value: "68", label: t("stats.year") },
    { value: "$447K", label: t("stats.avg") },
    { value: "EN / ES", label: t("stats.bilingual") },
  ];

  return (
    <section data-testid="stats-strip" className="border-y border-engraved bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-2 divide-x divide-engraved lg:grid-cols-4">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08, duration: 0.5 }}
            className="px-6 py-10 text-center"
          >
            <p className="font-serif text-3xl font-bold text-navy sm:text-4xl">{s.value}</p>
            <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-crimson">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default StatsStrip;
